import styled from "@emotion/styled";
import MainCard from "../elements/MainCard";
import Accordion from "../elements/Accordion";
import { HomeInfoCardId, InfoData, getHomeInfoCardData } from "./infoData";

import InfoCircleSvg from "../../../../assets/icons/splus3/info-circle.svg";

const RootDiv = styled(MainCard)(({ theme }) => ([
    {
        display: "none",
        flexDirection: "column",
        rowGap: 12,

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: {
            display: "flex"
        },
    }
]));

const HeaderDiv = styled.div([
    {
        display: "flex",
        columnGap: 12,
        alignItems: "center",
    }
]);

const HeaderText = styled.div([
    props => props.theme.splus3.typography.font16Lite,
    props => props.theme.splus3.foreground.primary,
    {
        flexGrow: 10,
        lineHeight: "137.5%",
    }
]);

const ContentDiv = styled.div([
    props => props.theme.splus3.typography.font12Lite,
    props => props.theme.splus3.foreground.monochrome600,
]);

interface InfoCardMobileProps {

}

const InfoCardMobile: React.FC<InfoCardMobileProps> = () => {
    const getItemHeader = (item: InfoData, _: boolean) => {
        return (
            <HeaderDiv>
                <img src={item.image} />
                <HeaderText>{item.text}</HeaderText>
                <div style={{ width: 16 }}>
                    <img src={InfoCircleSvg.src} style={{ transform: "translate(0px, 0px)" }} />
                </div>
            </HeaderDiv>
        );
    }

    const getItemContent = (item: InfoData) => {
        return <ContentDiv>{item.hintContent}</ContentDiv>
    }

    return (
        <RootDiv>
            <Accordion<InfoData> items={[
                getHomeInfoCardData(HomeInfoCardId.InternetSecurity),
                getHomeInfoCardData(HomeInfoCardId.Desktop),
                getHomeInfoCardData(HomeInfoCardId.Bundles)
            ]}
                getItemHeader={getItemHeader}
                getItemContent={getItemContent}
            />
        </RootDiv>
    );
}

export default InfoCardMobile;